import de from './de.json';
import en from './en.json';
import fr from './fr.json';

export default { en, de, fr };
